import { NotificationAlertType } from '../../types/notification-rules.types';

/**
 * The "Learn more" text for each alert type on the Notifications page.
 *
 * Kept in one place so it can be reviewed and edited without touching layout.
 * Every entry answers the same three questions in the same order, so someone
 * who has read one knows where to look in the others. These describe how the
 * alert pipeline behaves today; if that behaviour changes, change this too.
 */

export interface AlertExplainer {
    whatItIs: string;
    whatHappens: string;
    whatYoureChoosing: string;
}

export const ALERT_TYPE_EXPLAINERS: Record<NotificationAlertType, AlertExplainer> = {
    SOS: {
        whatItIs: 'A POM User presses SOS in the app or on their POM device.',
        whatHappens: 'POM Dispatch calls them right away and sends emergency services if needed. '
            + 'Dispatch handles the live event whatever you choose here.',
        whatYoureChoosing: 'Who on your side hears about it, and whether they hear while it’s happening or once '
            + 'it’s resolved. If EMS is actually sent, the call and email list further down is used as well.',
    },
    CheckOnMe: {
        whatItIs: 'A timer a POM User starts before a visit. They check out when they’re safely done.',
        whatHappens: 'They get a reminder shortly before it runs out. If it runs out, POM calls or texts them. '
            + 'If escalation is on and they still don’t respond, POM Dispatch takes over.',
        whatYoureChoosing: 'Who on your side hears about it. When they hear is set in Check On Me settings.',
    },
    Shift: {
        whatItIs: 'A longer timer for a whole working day, eight hours unless the POM User picks another length.',
        whatHappens: 'If the shift runs out without being ended, POM messages them to end it. If escalation is on, '
            + 'POM Dispatch takes over after a short grace period.',
        whatYoureChoosing: 'Who on your side hears when a shift runs out without being ended.',
    },
    RiskReview: {
        whatItIs: 'A visit flagged as a safety concern, from the short survey after a Check On Me or from a '
            + 'field safety report.',
        whatHappens: 'A Risk Review is created for someone to look at. Nothing goes to Dispatch.',
        whatYoureChoosing: 'Who is notified that a new review is waiting. Frontline team leaders often aren’t the right '
            + 'reviewers, so many organizations pick specific people here.',
    },
};
